import VideoImageAnimationTriggerController from "./video_image_animation_trigger_controller";


export default class extends VideoImageAnimationTriggerController {
    static targets = ["tab"]

    getCurrentVideoIndex() {
        return this.element.querySelector('button[aria-selected="true"]').dataset.index;
    }
    
    click(e) {
        this.triggerReplayEvent(e.currentTarget.dataset.index);
    }
}